<template>
    <div class="d-flex flex-column h-100 update-container">
        <header class="masthead mb-auto">
            <nav class="navbar navbar-expand-lg navbar-dark bg-no-trans">
                <div class="container-fluid">
                    <a class="navbar-brand" href="/#/">
                        <img src="../assets/img/logo.png" alt="Logo" />
                    </a>
                    <ul class="navbar-nav ml-auto align-items-center navWithSearch">
                        <li class="nav-item">
                            <a class="nav-link" href="#" tabindex="-1" aria-disabled="true">
                                <img v-bind:src="require(`@/assets/img/${this.n}.png`)" alt height="40px" width="40px"
                                    style="vertical-align: top" />
                            </a>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#" id="dropdown01" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false"> </a>
                            <div class="dropdown-menu dropdown-menu-right front" aria-labelledby="dropdown01">
                                <span class="dropdown-menu-arrow"></span>
                                <a class="dropdown-item front" href="/#/profile2"> Manage Profile</a>
                                <a class="dropdown-item front" href="/#/account">Account</a>
                                <a class="dropdown-item front" href="/#/mediaCenter">Help Center</a>
                                <a class="dropdown-item pointer front" @click="logout">Sign Out</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
        <section class="py-5  bg-grey200">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <div class="card custom-card">
                            <div class="card-body">
                                <h5 class="text-center text-green mt-4">
                                    Confirmation
                                </h5>
                                <div class="content row justify-content-center">
                                    <div class="form-group col-md-12 mt-1 mb-1">
                                        <p class="emailhead">
                                            Are you sure to delete Account?
                                        </p>
                                    </div>

                                </div>
                                <div class="row justify-content-center mt-4 mb-3">
                                    <div class="col-md-12 text-center">

                                        <button type="button" @click="deleteAccount"
                                            class="btn btn-lg btn-light ml-lg-2 mt-md-2">
                                            DELETE ACCOUNT
                                        </button>
                                        <button type="button" @click="cancelChange"
                                            class="btn btn-lg btn-light ml-lg-2 mt-md-2">
                                            CANCEL
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>

    </div>
</template>
  
<script>
import CountryCodes from "@/assets/json/CountryCodes.json";
export default {
    name: "DeleteAccount",
    components: {},
    computed: {
        userNotLoggedin() {
            return this.$store.state.user.logedin;
        },
    },

    mounted() {
        window.scroll(0, 0);
    },
    watch: {

    },
    created() {

    },

    methods: {
        cancelChange() {
            this.$router.push("/account");
        },

        logout() {
            this.$store.dispatch("logout").then((res) => {
                if (res == "true") {
                    this.$router.push("/");
                }
            });
        },
        deleteAccount() {
            this.$store
                .dispatch("deleteAccount")
                .then((res) => {
                    this.logout();
                    this.$store.commit("setNotification",res.message);
                     this.$store.commit("setLoader", false);
                })
                .catch((err) => {
                    this.$store.commit("setLoader", false);
                    this.$store.commit(
                        "setNotification",
                        err.response.data.error.message
                    );
                });
        },
        account() {
            this.$router.push("/account");
        },
        gotoAppStore(type) {
            if (type == "google") {
                window.open(
                    "https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
                    "_blank"
                );
            } else if (type == "apple") {
                window.open(
                    "https://apps.apple.com/gm/app/ibakatv/id1060646446",
                    "_blank"
                );
            }
        },

        gotoSingin() {
            this.$router.push("/login");
        },
        logout() {
			this.$store.dispatch("logout").then((res) => {
				if (res == "true") {
					this.$router.push("/");
				}
			});
		},


    },

    data() {
        return {
            n: 0,


        };
    },
};
</script>
<style scoped>
.emailhead {
    font-size: 15px;
    color: var(--text-primary-color);
    align-items: center !important;
    text-align: center;
    margin-top: 10px;
}

.verifybtn {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
}

.error-icon {
    top: -10px !important;
    margin-right: 3px;
    transform: translate(-50%, -12%);
}

.btn-verify {
    background-color: rgb(43, 42, 42);
    color: rgb(255, 255, 255) !important;
}

.btn-verify:hover,
.btn-primary:focus {
    background-color: rgb(43, 42, 42) !important;
    color: rgb(255, 255, 255) !important;
    border-color: var(--btn-outline-dark-border-color);
}

.forgotPassword {
    cursor: pointer;
    right: -95px;
}

.disable {
    cursor: pointer;
    background-color: #679F3D !important;
    border-color: #F1F2F2;

    color: #F1F2F2;
}


.py-5 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
    min-height: 80vh;
}
</style>